import { Alert, Button, ButtonGroup } from '@mui/material'
import React, { useContext, useState } from 'react'
import { selectDataHandler } from "../spatial-select/spatialSelectVM";
import useTablesDataHook from '../../table-panels/useTablesDataHook';
import { ISelectionDataModel } from '../../../../hooks/context/SelectionDataContext';
import { DeleteSweep } from '@mui/icons-material';
import { OcpwCreateWorkOrder} from '../../../../apis/OcpwAssetworks/OcpwAssetworksApi';
import CreateWorkOrder from '../../aim/buttons/CreateWorkOrder';
import ShowReportNewWindow from '../../reports/ShowReportNewWindow';
import CreatePackageBtn from '../../op-maint-inspections/inspect-package-tools/CreatePackageBtn';
import RejectPackageBtn from '../../op-maint-inspections/inspect-package-tools/RejectPackageBtn';
import { PageConfigurationContext } from '../../../../hooks/context/PageConfigurationContext';


const SelectionFormButtons = ({view, attributeObject,portal,callback}) => {
  const pageConfigurationCtx: any = useContext(PageConfigurationContext);
  const pageConfig = pageConfigurationCtx.data;
  const [showNoneSelectedAlert,setShowNoneSelectedAlert]=useState(false)
    const payload: ISelectionDataModel | any = useTablesDataHook()

    const handleDataFetch=(addToCurrentSelection)=>{
      selectDataHandler(view, attributeObject, addToCurrentSelection)
      .then(()=>{
        const selectColl = view.map.allLayers.filter(layer => layer.id === "selectionLayer")
        if (selectColl.length) {
          const selectionLayer = selectColl.getItemAt(0)
          if(selectionLayer.graphics.length<1){
            setShowNoneSelectedAlert(true)
            setTimeout(()=>{
              setShowNoneSelectedAlert(false)
            },3000)
          }else{
            setShowNoneSelectedAlert(false)
          }
        }
      })
      .catch((error)=>{console.log(error)})

    }

    const removeData = () => {
        const selectColl = view.map.allLayers.filter(layer => layer.id === "selectionLayer")
        if (selectColl.length) {
          const selectionLayer = selectColl.getItemAt(0)
          selectionLayer.removeAll();
        }
        callback();
      }

  return (
    <>
    <ButtonGroup fullWidth>
  <Button size={'small'} variant="outlined" 
  sx={{fontSize:10, height:"40px"}}
  onClick={(e) => {
        e.preventDefault();
        handleDataFetch(true);

      }}>+ Add to selection</Button>
    <Button size={'small'} variant="contained" sx={{fontSize:10, height:"40px"}} onClick={(e) => {
        e.preventDefault();
        handleDataFetch(false);
    }}>New selection</Button>
      <Button size={'small'} disabled={!payload.length} color="error" id="remove-all-selectData" startIcon={<DeleteSweep></DeleteSweep>} variant="contained" onClick={removeData} sx={{fontSize:10, height:"40px"}}>Clear selected</Button>
     </ButtonGroup>
      {pageConfig.widgets?.opMaintInspectionTools?.show&&<ButtonGroup fullWidth sx={{marginTop: '10px'}}>
        <CreatePackageBtn payload={payload} view={view}></CreatePackageBtn>
        {/* <RejectPackageBtn payload={payload} view={view}></RejectPackageBtn> */}
    {/* <CreateWorkOrder payload={payload} portal={portal}></CreateWorkOrder> */}
    <ShowReportNewWindow token={portal?.credential?.token}></ShowReportNewWindow>
      </ButtonGroup>}
      {showNoneSelectedAlert &&
      <Alert severity='warning' sx={{marginTop:'20px'}}>your selection returned 0 records</Alert>
        
      }
    </>

  )
}

export default SelectionFormButtons